import classNames from 'classnames';
import React, {ReactElement} from 'react';

type Props = {
  // Between 0 and 1
  progress: number;
  className?: string;
};

const ProgressBar = ({progress, className}: Props): ReactElement => {
  const inBounds = Math.max(0, Math.min(1, progress));
  const percent = inBounds * 100;

  return (
    <div
      className={classNames(
        'h-6 rounded-full mt-6 border-normal border-gray-100 shadow-solid-light-green bg-white overflow-hidden',
        className
      )}
    >
      <div
        className={'h-full rounded-full striped-background transition-[width] duration-1000'}
        style={{width: `${percent}%`}}
      />
    </div>
  );
};

export default ProgressBar;
